import React, { useState } from "react";
import { Input, Space, Table, Tag } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const RoomTable = ({ dataSource, selectedRow, onRowSelect }) => {
  const [searchText, setSearchText] = useState("");

  const columns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
      align: 'center',
      width: 70,
    },
    {
      title: "Room No",
      align: 'center',
      dataIndex: "room_number",
      render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>
    },

    {
      title: "Max Occupancy",
      align: 'center',
      dataIndex: "max_occupancy",
      render: (max_occupancy) => <span style={{ fontWeight: 500 }}>{max_occupancy} Person</span>
    },
    {
      title: "Type",
      dataIndex: "room_type",
      render: (type) => (
        <Tag
          color="blue"
          style={{
            borderRadius: 6,
            padding: "2px 10px",
            fontWeight: 500
          }}
        >
          {type}
        </Tag>
      )
    },
    {
      title: "Price",
      render: (_, record) => (
        <div style={{ fontSize: "13px" }}>
          <div style={{ fontWeight: 600, color: "#52c41a" }}>
            ₹{record.price_per_day} / day
          </div>
          <div style={{ color: "#8c8c8c", marginTop: 2 }}>
            ₹{record.price_per_hour} / hr
          </div>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <Tag
          color={status === "available" ? "success" : "error"}
          style={{
            borderRadius: 6,
            padding: "4px 12px",
            fontWeight: 500,
            border: "none"
          }}
        >
          {status.toUpperCase()}
        </Tag>
      ),
    },
  ];

  // ✅ Filtering logic
  const filteredData = dataSource.filter((item) => {
    const search = searchText.toLowerCase();

    return Object.values(item).some((value) => {
      if (value === null || value === undefined) return false;

      return String(value).toLowerCase().includes(search);
    });
  });

  return (
    <>
      <style>{`
        .room-table .ant-table-tbody > tr {
          transition: all 0.2s ease;
        }

        .room-table .ant-table-tbody > tr:hover {
          background: #f8f9ff !important;
          cursor: pointer;
          transform: translateX(2px);
        }

        .room-table .ant-table-tbody > tr > td {
          padding: 14px 12px;
          border-bottom: 1px solid #f0f0f0;
        }

        .room-table .ant-table-row-selected {
          background: linear-gradient(90deg, #e6f0ff 0%, #f0f5ff 100%) !important;
        }

        .room-table .ant-table-row-selected:hover {
          background: linear-gradient(90deg, #e6f0ff 0%, #f0f5ff 100%) !important;
        }

        .room-table .ant-pagination {
          margin: 20px 0 10px;
        }
      `}</style>

      <Space style={{ paddingBottom: '12px' }}>
        <Input
          prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
          style={{ width: 400 }}
          size="large"
          placeholder="Search..."
          allowClear
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </Space>

      <Table
        className="room-table"
        columns={columns}
        dataSource={filteredData} // ✅ use filtered data
        rowKey="id"
        pagination={{
          pageSize: 10,
          showSizeChanger: false,
          showTotal: (total) => `Total ${total} rooms`
        }}
        rowClassName={(record) =>
          record.id === selectedRow?.id ? "ant-table-row-selected" : ""
        }
        onRow={(record) => ({
          onClick: () => onRowSelect(record),
        })}
      />
    </>
  );
};

export default RoomTable;